/* Pause controls for decorative video. Shopping and form logic remain native. */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function enhance(root = document) {
    root.querySelectorAll('.shopify-section--slideshow,.shopify-section--video').forEach(section => {
      if (section.querySelector('.cfa-motion-control')) return;
      const videos = [...section.querySelectorAll('video-media[autoplay] video')];
      if (!videos.length) return;
      let paused = reducedMotion.matches;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cfa-motion-control';
      const update = () => {
        button.innerHTML = paused
          ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>'
          : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 5h4v14H7zm6 0h4v14h-4z" fill="currentColor"/></svg>';
        button.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
      };
      videos.forEach(video => {
        video.addEventListener('play', () => { if (paused) video.pause(); });
        if (paused) video.pause();
      });
      button.addEventListener('click', () => {
        paused = !paused;
        videos.forEach(video => {
          const slide = video.closest('.slideshow__slide');
          if (paused) video.pause();
          else if ((!slide || slide.classList.contains('is-selected')) && video.getBoundingClientRect().width > 0) video.play().catch(() => { paused = true; update(); });
        });
        update();
      });
      reducedMotion.addEventListener('change', event => {
        if (event.matches) { paused = true; videos.forEach(video => video.pause()); update(); }
      });
      section.append(button);
      update();
    });
  }
  enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target.parentElement));
})();
